import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React from 'react';
import { FieldError } from 'react-hook-form';

import styles from './styles.module.scss';

interface MuiToggleProps {
  label: string;
  hideLabel?: boolean;
  required?: boolean;
  options: { value: string; label: string }[];
  selectedValue: string;
  onChange: (value: string) => void;
  height?: string;
  width?: string;
  error?: FieldError;
  disabled?: boolean;
}

const MuiToggle: React.FC<MuiToggleProps> = ({
  label,
  options,
  hideLabel = false,
  required = true,
  selectedValue,
  onChange,
  height = '100%',
  width = '100%',
  error,
  disabled = false,
}) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: string | null): void => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <div className={styles.toggleContainer} style={{ height, width }}>
      {!hideLabel && (
        <label className={styles.toggleLabel} htmlFor={label}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <ToggleButtonGroup
        value={selectedValue}
        exclusive
        onChange={handleChange}
        disabled={disabled}
        className={styles.toggleGroup}
        style={{ width: width !== '100%' ? width : 'fit-content' }}
      >
        {options.map((option) => (
          <ToggleButton
            key={option.value}
            value={option.value}
            className={`${styles.toggleButton} ${selectedValue === option.value ? styles.selected : ''}`}
            data-testid={`medical-history-${option.value}`}
            disabled={disabled}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {error && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
          {error.message}
        </Typography>
      )}
    </div>
  );
};

export default MuiToggle;
